// DESCRIPTION: Renders a price badge showing "Free" or formatted price
// for event cards and list items.

import { __ } from '@wordpress/i18n';

const PriceBadge = ( { price, currencySymbol } ) => {
	if ( price === 0 || ! price ) {
		return (
			<span className="nb-inline-flex nb-items-center nb-px-2.5 nb-py-0.5 nb-rounded-full nb-text-xs nb-font-medium nb-bg-emerald-50 nb-text-emerald-700">
				{ __( 'Free', 'nemtly-booking' ) }
			</span>
		);
	}

	return (
		<span className="nb-inline-flex nb-items-center nb-px-2.5 nb-py-0.5 nb-rounded-full nb-text-xs nb-font-medium nb-bg-slate-100 nb-text-slate-700">
			{ currencySymbol }
			{ parseFloat( price ).toFixed( 2 ) }
		</span>
	);
};

export default PriceBadge;
